module.exports = __webpack_public_path__ + "static/img/1.b989d00.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/4/eng/1.png
// module id = u4Y5
// module chunks = 0